import type { ReactNode } from 'react';

/**
 * The site's ONE look for "this piece of data is hidden behind Pro".
 *
 * Owner, 2026-10-07, on the outcome wall: «этот чип должен быть точно такой же,
 * как мы в других местах используем, когда скрываем данные: такой же замочек,
 * такой же цвет чипа и текста. Слишком много разных цветов.» So nothing here is
 * new — both halves are lifted from the places that already hid data:
 *
 *  - the chip is the locked analytics teasers' pill (`TeaserPill` in
 *    `analytics-teaser-bodies.tsx`, the HHI / re-listing / deposit pills), which
 *    is in turn the catalogue's neutral chip (the supply badge on a list row):
 *    bone fill, `edge` border, 11 px bold `ink-soft` text;
 *  - the lock is the 🔒 emoji the tender page wears on every gated thing (the
 *    gate card's rows, the documents teaser, «Открыть оригинал», the buyer
 *    profile link) — NOT `LockIcon`, which is /plans' button glyph. See the
 *    note in `analytics-teaser.tsx` on why the emoji stayed (a tofu box in a
 *    screenshot was this host's missing emoji font, not a real device).
 *
 * Change the look here and every hidden-data chip changes with it.
 */
export const LOCKED_CHIP_CLASS =
  'inline-flex items-center overflow-hidden rounded-pill border border-edge bg-bone px-2 py-0.5 text-[11px] font-bold leading-[1.5] tabular-nums text-ink-soft';

/** The padlock, as the tender page has always written it. Decorative: the text
 *  beside it says what is locked. */
export function LockGlyph({ className }: { className?: string }) {
  return (
    <span aria-hidden="true" className={className}>
      🔒
    </span>
  );
}

/** A locked-data chip: the padlock + a short line saying what Pro shows here.
 *  `max-w-full` + a wrapping inner span: a long line (the lot page's outcome
 *  wall) wraps inside the chip instead of pushing out of a phone-width card. */
export function LockedChip({
  children,
  className,
  testId,
}: {
  children: ReactNode;
  className?: string;
  testId?: string;
}) {
  return (
    <span
      className={`${LOCKED_CHIP_CLASS} max-w-full gap-1${className ? ` ${className}` : ''}`}
      data-testid={testId}
    >
      <LockGlyph className="shrink-0" />
      <span className="min-w-0">{children}</span>
    </span>
  );
}
